import { useEffect, useRef } from "react";

import { useSearchParams } from "next/navigation";

import { disposeApi } from "@/api";
import { useStore } from "@/store";
import { useChats } from "@/store/useChats";

export function useOpenChatFromQuery(routeDocId?: string) {
  const { doc } = useStore();
  const chats = useChats();

  const queryParams = useSearchParams();
  const pendingRef = useRef({
    chatUid: queryParams.get("chat"),
    messageUid: queryParams.get("message") ?? undefined,
  });

  const docId = doc?.id;
  const isFetched = doc?.api.isFetched;

  useEffect(() => {
    const { chatUid, messageUid } = pendingRef.current;
    if (!chatUid || !docId || !isFetched) return;
    // The store can still hold the previous doc while the route doc loads
    if (routeDocId && docId !== routeDocId) return;

    pendingRef.current.chatUid = null;

    return disposeApi(async (signal) => {
      await chats.openChatByUid(chatUid, messageUid);
      if (signal.aborted) return;

      // Native replaceState avoids the router navigation that would remount the doc
      window.history.replaceState(null, "", window.location.pathname);
    });
  }, [docId, isFetched, chats, routeDocId]);
}
